import { handleApiError } from "@/app/utils/handleApiError";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchRegisterSendCode,
  fetchRegisterVerifyCode,
  fetchLoginSendCode,
  fetchLoginVerifyCode,
  fetchLogout,
  fetchDeleteAccount,
  fetchUserProfile,
} from "./auth.service";
import { RejectValueType } from "../redux/redux.types";
import {
  RegisterRequest,
  RegisterResponse,
  LoginSendCodeRequest,
  LoginVerifyCodeRequest,
  LoginResponse,
  LogoutResponse,
  DeleteAccountResponse,
  UserProfileResponse,
} from "./auth.types";

export const registerSendCode = createAsyncThunk<
  RegisterResponse,
  RegisterRequest,
  RejectValueType
>("auth/registerSendCode", async (data, { rejectWithValue }) => {
  try {
    return await fetchRegisterSendCode(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const registerVerifyCode = createAsyncThunk<
  RegisterResponse,
  RegisterRequest,
  RejectValueType
>("auth/registerVerifyCode", async (data, { rejectWithValue }) => {
  try {
    return await fetchRegisterVerifyCode(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const loginSendCode = createAsyncThunk<
  LoginResponse,
  LoginSendCodeRequest,
  RejectValueType
>("auth/loginSendCode", async (data, { rejectWithValue }) => {
  try {
    return await fetchLoginSendCode(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const loginVerifyCode = createAsyncThunk<
  LoginResponse,
  LoginVerifyCodeRequest,
  RejectValueType
>("auth/loginVerifyCode", async (data, { rejectWithValue }) => {
  try {
    return await fetchLoginVerifyCode(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const logoutUser = createAsyncThunk<
  LogoutResponse,
  void,
  RejectValueType
>("auth/logout", async (_, { rejectWithValue }) => {
  try {
    return await fetchLogout();
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const deleteAccount = createAsyncThunk<
  DeleteAccountResponse,
  void,
  RejectValueType
>("auth/deleteAccount", async (_, { rejectWithValue }) => {
  try {
    return await fetchDeleteAccount();
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getUserProfile = createAsyncThunk<
  UserProfileResponse,
  void,
  RejectValueType
>("auth/getUserProfile", async (_, { rejectWithValue }) => {
  try {
    return await fetchUserProfile();
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
